<template>
    <tbody> 
        <!-- Render only if visible (based on zero/balance condition) -->
        <tr 
            v-if="shouldShowAccount" 
            :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''"
        >
            <td :style="nodeMargin+' text-transform: uppercase;'"> 
                <!-- Expand / Collapse Icon If Has Children -->
                <span 
                    v-if="hasChildren" 
                    @click="toggleChildren" 
                    style="cursor: pointer; margin-right: 5px;"
                >
                    <i :class="toggleChildrenIcon"></i>
                </span>
                <!-- If No Children — show empty space for alignment -->
                <span v-else style="padding-right: 20px;"></span>
                
                <!-- Account Name -->
                <span v-if="showCode">
                    {{ account.name }} [{{ account.code }}]
                </span>
                <span v-else>
                    {{ account.name }}
                </span>
        
            </td>
            <td class="text-right" style="text-align: right;">
                {{ formatNumberWithDecimals(account.balance, 2) }}
            </td>
        </tr>

        <!-- <tr v-else-if="sumvalue(account)" :style="(account.account_type != 'ledger') ? 'font-weight: bold' : ''">
            <td v-if="code_active" :style="nodeMargin+' text-transform: uppercase;'">{{ account.name }} [{{ account.code }}] </td>
            <td v-else :style="nodeMargin+' text-transform: uppercase;'">  {{ account.name }}</td>
            <td class="text-right" style="text-align: right;">{{ formatNumberWithDecimals(account.balance, 2) }}</td>
        </tr> -->
    </tbody>               
    <!-- <AccountProfitLoss v-if="hasChildren" v-for="(child, c) in account.children" :key="c" :account="child" :level="(level + 1)" :spaces="(spaces + 15)" :code_active="showCode" :zero_active="showZeroRow"></AccountProfitLoss> -->
    <AccountProfitLoss 
        v-if="hasChildren && showChildren" 
        v-for="(child, c) in account.children" 
        :key="c" 
        :account="child" 
        :level="level + 1" 
        :spaces="spaces + 15" 
        :code_active="showCode" 
        :zero_active="showZeroRow"
    />
</template>

<script>

    export default {
        name: 'AccountProfitLoss',
        emit:['add-child', 'edit-item', 'delete-item'],
        props: {
            account: { type: Object, required: true },
            level: { type: Number, default: 0 },
            spaces: { type: Number, default: 0 },
            code_active: { type: Boolean, default: false },
            zero_active: { type: Boolean, default: false }

        },
        data() {
            return {
                showChildren: false,
            }
        },
        computed: {
            accountLevel() {
                return this.level;
            },

            nodeMargin() {
                return 'padding-left: '+`${this.spaces}px;`;
            },

            hasChildren() {
                const { children } = this.account;
                return children && children.length > 0
            },

            toggleChildrenIcon() {
                return this.showChildren ? 'mdi mdi-chevron-down' : 'mdi mdi-chevron-left';
            },
            showCode() {
                return this.code_active;
            },
            showZeroRow() {
                return this.zero_active;
            },
            shouldShowAccount() {
                const isZero = !this.sumvalue(this.account);
                return this.zero_active ? true : !isZero;
            }

            
        },
        methods: {
            toggleChildren() {
                this.showChildren = !this.showChildren;
            },            
            sumvalue(account){
                let sumVal = Number(parseFloat(account.balance ?? 0)).toFixed(3);
                if(sumVal == '0.000' || sumVal == '-0.000') {
                    return false;
                }else{
                    return true;
                }
            }
        }
    }

</script>
 